// Isolado num módulo para os testes poderem mockar a navegação de página inteira.
export const currentPathname = () => window.location.pathname;
export const currentPath = () => `${window.location.pathname}${window.location.search}`;
export const navigateTo = (url) => window.location.assign(url);
